import React from 'react';
import slugify from 'react-slugify';
import { VuiEmptyPlaceholder } from '@topkamera/viso-ui';

export const Status404Page = ({
  parentClass, workspace
}) => (
  <main className={`not-found__wrapper not-found__wrapper--middle ${parentClass}`}>
    <VuiEmptyPlaceholder
      title='Page Not Found'
      size='lg'
      color='card-border'
      description='The page you are looking for does not exist or has been moved to a new location.'
      icon='disabledThin'
      action={{
        label: 'Go Home',
        to: workspace && `/${slugify(workspace.name)}`,
      }}
    />
  </main>
);

export default Status404Page;
